import React, { Fragment, useEffect } from "react";
import mixpanel from "mixpanel-browser";
import { TitleHero } from "../components";

const TitleLandingPage = () => {
  
  useEffect(() => {
    mixpanel.track('Title Landing Page', {'action' : 'pageview'})
}, [,])
  
  return (
  <Fragment>
    <TitleHero/>
  </Fragment>
);}

export default TitleLandingPage;